export const GET_ORGANIZATION_MEMBERS_START =
  'GET_ORGANIZATION_MEMBERS_START';
export const GET_ORGANIZATION_MEMBERS_SUCCESS =
  'GET_ORGANIZATION_MEMBERS_SUCCESS';
export const GET_ORGANIZATION_MEMBERS_ERROR =
  'GET_ORGANIZATION_MEMBERS_ERROR';
